module.exports = __webpack_public_path__ + "static/media/Logo.6be8ac17.png";